import { render, staticRenderFns } from "./ActivationPage.vue?vue&type=template&id=27b203d4&scoped=true&"
import script from "./ActivationPage.vue?vue&type=script&lang=js&"
export * from "./ActivationPage.vue?vue&type=script&lang=js&"
import style0 from "./ActivationPage.vue?vue&type=style&index=0&id=27b203d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b203d4",
  null
  
)

export default component.exports